import React, { Component } from "react";
import Hero from './../../components/hero';
import { Link } from "react-router-dom";
import  './../../utils/analytics';
import  {Colors} from './../../utils/variables';
import ScrollFadeIn from './../../components/scrollFadeIn';
import './camping.scss';

export default class extends Component {
  componentDidMount = ()=>{
    window.scrollTo(0, 0)
  }
  render() {
    return (
		<div className="light-grey-background camping-page" style={{backgroundColor:Colors.primaryDark}}>
      <div className="slant-bottom">
        {/* Temporary: hide Book your site — restore buttonText / buttonLink on Hero when booking reopens */}
        <Hero
          title={'Camp With Us'}
          backgroundImage={'/images/camping-hero.jpg'}
          height={'threequarter'} /*full, half,threequarter*/
          tint={''}
        />
      </div>
      <div>
        <div className="gutter">
          <div className="medium-max-width-container lip shadow" style={{color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="large-padding centered-text" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <p><strong>{'25 spots available.'}</strong> {'Camping for Peak Pursuits is first come, first serve.'}</p>
              <p>{'Reservations are for confirmed paid participants of Free to Roam only.'}</p>
              <p><strong>{'$75 the weekend, per vehicle.'}</strong></p>
              <p>{'Camping is located in the Upper Red Cliffs parking lot at Kirkwood Mountain Resort. Campers must show proof of Peak Pursuits camping registration when checking in.'}</p>
              <p>{'All campers must check-in with a Peak Pursuits representative or designated Kirkwood Staff, prior to selecting a camp site.'}</p>
              <p>{'Camping permits must be displayed in the vehicle at all times.'}</p>
            </div>
          </div>
        </div>

        
        {/* Camping Features */}
        <ScrollFadeIn>
          <div className="medium-max-width-container shadow" style={{marginTop:'5vh', marginBottom:'5vh', color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="row alternating-grid-row" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="small-12 medium-6">
                <img className="alternating-grid-image" alt="" src="images/square.png" style={{'backgroundImage':'url(images/camp.jpg)'}} />
              </div>
              <div className="small-12 medium-6 row">
                <div className="alternating-grid-text center-position">
                  <h2>{"FEATURES"}</h2>
                  <ul className="subheading" style={{lineHeight:1.5}}>
                    <li>{'Portable toilets, hand wash station, trash/recycling are provided.'}</li>
                    <li>{'RV/Campers and tent campers must be self-contained. No water, electric, dump stations, or sewer hookups available.'}</li>
                    <li>{'Maximum RV or Trailer length is 30\''}</li>
                    <li>{'Each space is allowed one additional vehicle.'}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>

        {/* Check In & Out Procedures */}
        <ScrollFadeIn>
          <div className="medium-max-width-container shadow" style={{marginTop:'5vh', marginBottom:'5vh', color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="row alternating-grid-row reverse" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="small-12 medium-6">
                <img className="alternating-grid-image" alt="" src="images/square.png" style={{'backgroundImage':'url(images/camping-1.jpg)'}} />
              </div>
              <div className="small-12 medium-6 row">
                <div className="alternating-grid-text center-position" style={{color:Colors.white}}>
                  <h2>{"CHECK IN/OUT"}</h2>
                  <ul className="subheading" style={{lineHeight:1.5}}>
                    <li>{'Check-in: starting 8/14/27 from 12pm-7pm, operated by Peak Pursuits representative or Kirkwood Staff, at the entrance of the Red Cliffs Parking lot.'}</li>
                    <li>{'Late check-ins will need to contact Kirkwood Security in the Red Cliffs Lodge or by calling 209-258-7528.'}</li>
                    <li>{'Check-out: by 4pm on 8/16/27.'}</li>
                    <li>{'For additional questions, please work with Peak representatives prior to or during check-in times (if after hours – call Kirkwood Security).'}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>  
        <div className="medium-max-width-container" style={{marginTop:'2vh', marginBottom:'2vh', color:Colors.white}}>
            <div className="large-padding centered-text">
              <h2>{"Tips and Details"}</h2>
              <div className="row" style={{alignItems:'stretch'}}>
                <div className="small-12 medium-12 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'We know some of you like to arrive early (on Friday), and that\'s ok! Please note that the best time to get our full attention and check-in/register is starting at 4pm when we have everything organized and ready for you :) If you arrive early, you are welcome to set up your site or check into your room. A formal dinner will not be included on Friday night. Our photographers and videographers will be onsite to capture footage. Please let us know if you are camera shy.'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </ScrollFadeIn>
        {/* Camping Rules & Etiquette */}
        {/* 
        <ScrollFadeIn>
          <div className="medium-max-width-container" style={{marginTop:'2vh', marginBottom:'2vh', color:Colors.white}}>
            <div className="large-padding centered-text">
              <h2>{"RULES & ETIQUETTE"}</h2>
              <div className="row" style={{alignItems:'stretch'}}>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Quiet time is from 10pm to 5am. No generators may be running during this time.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Take pride in your campsite and keep it free of trash. Dumpsters are provided for your use.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Be courteous to your neighbors and Peak Pursuits & Kirkwood staff.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Be aware that exhaust and smoke from vehicles, BBQ\'s, and generators can negatively affect your neighbors. Know which way the wind blows.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Propane BBQ\'s or stoves are allowed unless prohibited by local fire restrictions.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'No charcoal BBQ\'s, campfires, fire pits, open fires, or fireworks allowed.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Smoking allowed in designated area only by dumpsters.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'Drones are prohibited.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-4 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'You must keep your camp within your designated spot.'}</p>
                  </div>
                </div>
                <div className="small-12 medium-12 tiny-padding">
                  <div className="card primary-background" style={{borderRadius:10, padding:20, height:'100%', backgroundImage:'url(/images/topo-texture.png)'}}>
                    <p className="white subheading">{'No objects will be secured to the pavement by stakes. You may use your own weighted bags. Please do not damage the pavement any further than it may already be.'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        */}
        {/* Pet Policy */}
        {/* 
        <ScrollFadeIn>
          <div className="medium-max-width-container shadow" style={{marginTop:'5vh', marginBottom:'5vh', color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="row alternating-grid-row reverse" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="small-12 medium-6">
                <img className="alternating-grid-image" alt="" src="images/square.png" style={{'backgroundImage':'url(images/donut.jpg)'}} />
              </div>
              <div className="small-12 medium-6 row">
                <div className="alternating-grid-text center-position" style={{color:Colors.white}}>
                  <h2>{"PET POLICY"}</h2>
                  <ul className="subheading" style={{lineHeight:1.5}}>
                    <li>{'Maximum of 2 dogs per site.'}</li>
                    <li>{'Clean up after your dogs.'}</li>
                    <li>{'Dogs must be leashed at all times.'}</li>
                    <li>{'Dogs are not allowed in lodges, or to be left in vehicles during the day or unattended at any time.'}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        */}
        {/* Food Options */}
        {/* 
        <ScrollFadeIn>
          <div className="medium-max-width-container shadow" style={{marginTop:'5vh', marginBottom:'5vh', color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="row alternating-grid-row" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="small-12 medium-6">
                <img className="alternating-grid-image" alt="" src="images/square.png" style={{'backgroundImage':'url(images/gen-store.jpg)'}} />
              </div>
              <div className="small-12 medium-6 row">
                <div className="alternating-grid-text center-position" style={{color:Colors.white}}>
                  <h2>{"FOOD OPTIONS"}</h2>
                  <ul className="subheading" style={{lineHeight:1.5}}>
                    <li><strong>{'Kirkwood General Store'}</strong>{' (1501 Kirkwood Meadows Drive): Open every day from 8am – 5pm. Located in the Red Cliffs Lodge, the General Store offers an outdoor BBQ station, pre-made sandwiches, hand-scooped ice cream, beverages, and other general provisions.'}</li>
                    <li><strong>{'Caples Lake Resort & Restaurant'}</strong>{' (1111 HWY 88, Kirkwood, CA 95646): The restaurant is closed Mondays & Tuesdays (Lounge opens at 3pm / Dining Room opens at 5pm). Visit capleslakeresort.com for more information.'}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        */}
         {/* Confirmation & Cancellations */}
         <ScrollFadeIn>
          <>
            <h2 className="white medium-padding centered-text" style={{color:Colors.white}}>{"Site Map"}</h2>
            <div className="medium-max-width-container shadow" style={{marginBottom:'2vh', color:Colors.white, backgroundColor:Colors.primary}}>
              <div className="centered-text" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
                <img className="full-width" src="/images/camp-map.jpg" />
              </div>
            </div>
          </>
        </ScrollFadeIn>

        {/* Confirmation & Cancellations */}
        <ScrollFadeIn>
          <div className="medium-max-width-container shadow" style={{marginTop:'5vh', marginBottom:'5vh', color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="large-padding centered-text" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <h2>{"CONFIRMATION & CANCELLATIONS"}</h2>
              <p className="subheading">{'Please cancel your camping reservation through Peak Pursuits if you are unable to attend. No full refunds for campsites will be given at any time.'}</p>
            </div>
          </div>
        </ScrollFadeIn>
        
        <div className="slant-top large-padding centered-text" style={{color:Colors.white}}>
          <ScrollFadeIn>
            <div className="small-max-width-container">
              <p className="subheading">{'Failure to follow the outlined rules or failure to be courteous to other campers or staff, will result in immediate termination of your camping spot. You will be required to leave Kirkwood Mountain Resort property immediately. Failure to leave will result in law enforcement being contacted.'}</p>
              <div className="small-padding" style={{paddingBottom:0}}>
                <p><b>{'Note: Please remove trash daily to the dumpster to minimize bear activity at camp.'}</b></p>
              </div>
            </div>
          </ScrollFadeIn>
        </div>
        <div>
          <ScrollFadeIn>
            <div className="shadow" style={{color:Colors.white, backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="large-padding centered-text">
                <h1>{'Ready to Camp?'}</h1>
                <p className="cursive-text subheading">{'Camping is available for confirmed Free to Roam participants only'}</p>
                <a href="https://square.link/u/JRbwq3dX" target="_blank" className="camping-book-site-link--hidden">
                  <div className="card-button button" style={{color:Colors.white, backgroundColor:Colors.tertiary}}>
                    {'Book your site'}
                  </div>
                </a>
              </div>
            </div>
          </ScrollFadeIn>
        </div>
      </div>
    </div>
    );
  }
}
